import React from 'react'

function ImagePopupBox({ setOpenImg, imgSrc }) {
    return (
        <div>
            <div className=" delete_activity_transprant_body">
                <img
                    style={{ position: "absolute", top: "1%", left: "92%" }}
                    src="./images/cross.png"
                    className=" rounded-circle"
                    alt=""
                    onClick={(e) => setOpenImg(false)}
                />

                <div className=" p-3 d-flex align-items-center justify-content-center flex-column shadow">
                    <img src={imgSrc} alt='img' style={{ width: "95%", height: "80%" }}></img>
                </div>
            </div>
        </div>
    )
}

export default ImagePopupBox